/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const scissors = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M15 2.91 1.955 10.944m0 0A2.227 2.227 0 1 0 4.5 14.6a2.227 2.227 0 0 0-2.545-3.656ZM15 13.09 1.955 5.055m0 0A2.227 2.227 0 1 0 4.5 1.4a2.227 2.227 0 0 0-2.545 3.656Z"
    />
  </svg>
)
export default scissors
